import { TaxRateTypeEnum } from '../../../shared/enums/tax-rate-type.enum';
import { AppSubjectEnum } from '../../../shared/modules/authz/enums/app-subject.enum';
import { CaslSubject } from '../../../shared/modules/authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../../shared/modules/base/dtos/base.dto';
import { FileDto } from '../../../shared/modules/files/dtos/file.dto';
import { AgentSearchDto } from '../../agents';
import { CustomerSearchDto } from '../../customers';
import { LocationSearchDto } from '../../locations';
import { PaymentActivityTrackingDto } from '../../payment-activity-tracking/dtos/payment-activity-tracking.dto';
import { PaymentStatusEnum } from '../../payments/enums/payment-status.enum';
import { RentalAgreementSearchDto } from '../../rental-agreements';
import { RentalReservationSearchDto } from '../../rental-reservations';
import { SupplierSearchDto } from '../../suppliers';
import { TagListDto } from '../../tags/dtos/tag-list.dto';
import { VehicleInsuranceSearchDto } from '../../vehicle-insurances';
import { VehicleMaintenanceSearchDto } from '../../vehicle-maintenances';
import { VehicleRoadTaxSearchDto } from '../../vehicle-road-taxes';
import { VehicleRoadWorthyCheckSearchDto } from '../../vehicle-road-worthy-checks';
import { VehicleSearchDto } from '../../vehicles';
import { TransactionRecordCategoryEnum } from '../enums/transaction-record-category.enum';
import { TransactionStatusEnum } from '../enums/transaction-status.enum';
import { TransactionTypeEnum } from '../enums/transaction-type.enum';

import { TransactionLinksDto } from './transaction-links.dto';

/**
 *  Transaction record DTO
 */
@CaslSubject(AppSubjectEnum.TRANSACTION)
export class TransactionRecordDto extends BaseDto {
  code!: string;
  externalReference?: string | null;
  recordCategory!: TransactionRecordCategoryEnum;
  type!: TransactionTypeEnum;
  status!: TransactionStatusEnum;
  description?: string | null;
  notes?: string | null;
  locationId?: number | null;
  location?: LocationSearchDto | null;
  customerId?: number | null;
  customer?: CustomerSearchDto | null;
  supplierId?: number | null;
  supplier?: SupplierSearchDto | null;
  agentId?: number | null;
  agent?: AgentSearchDto | null;
  vehicleId?: number | null;
  vehicle?: VehicleSearchDto | null;
  rentalAgreementId?: number | null;
  rentalAgreement?: RentalAgreementSearchDto | null;
  rentalReservationId?: number | null;
  rentalReservation?: RentalReservationSearchDto | null;
  vehicleRoadWorthyCheckId?: number | null;
  vehicleRoadWorthyCheck?: VehicleRoadWorthyCheckSearchDto | null;
  vehicleRoadTaxId?: number | null;
  vehicleRoadTax?: VehicleRoadTaxSearchDto | null;
  vehicleInsuranceId?: number | null;
  vehicleInsurance?: VehicleInsuranceSearchDto | null;
  vehicleMaintenanceId?: number | null;
  vehicleMaintenance?: VehicleMaintenanceSearchDto | null;
  paymentId?: number | null;
  paymentStatus?: PaymentStatusEnum | null;
  paymentExternalStatus?: string | null;
  paymentActivityTracking?: PaymentActivityTrackingDto[] | null;
  taxRateType?: TaxRateTypeEnum | null;
  taxRate?: number | null;
  isTaxIncluded?: boolean | null;
  amount?: number | null;
  totalNet?: number | null;
  totalTax?: number | null;
  totalGross?: number | null;
  tags?: TagListDto[] | null;
  links?: TransactionLinksDto | null;
  files?: FileDto[] | null;
}
